import type { SVGProps } from "react";

export function DeepSeekLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      {/* Stylized whale silhouette */}
      <path d="M2 13 C 4 9, 9 7, 14 8 C 18 8.6, 21 11, 22 13 L 20 13.5 L 21.5 16 L 18 14.5 C 16 16, 13 16.5, 10 16 C 6 15.4, 3 14.5, 2 13 Z" />
      <circle cx="17" cy="11" r="0.9" fill="var(--ivory)" />
    </svg>
  );
}
